import { gql, useQuery } from '@apollo/client';

export const DPO_AUDIT_REPORT_HISTORY_FIELDS = gql`
  fragment DpoAuditReportHistoryFields on DpoAuditReportHistory {
    id
    createdAt
    companyId
  }
`;

export const GET_DPO_AUDIT_REPORT_HISTORY = gql`
  ${DPO_AUDIT_REPORT_HISTORY_FIELDS}
  query GetDpoAuditReportHistory($companyId: String!) {
    getDpoAuditReportHistory(companyId: $companyId) {
      ...DpoAuditReportHistoryFields
    }
  }
`;

export interface DpoAuditReportHistoryEntry {
  id: string;
  createdAt: string;
  companyId: string;
}

export interface GetDpoAuditReportHistoryResult {
  getDpoAuditReportHistory: DpoAuditReportHistoryEntry[];
}

export interface GetDpoAuditReportHistoryInput {
  companyId: string;
}

export function useDpoAuditReportHistoryQuery(companyId: string | undefined) {
  return useQuery<GetDpoAuditReportHistoryResult, GetDpoAuditReportHistoryInput>(
    GET_DPO_AUDIT_REPORT_HISTORY,
    {
      variables: { companyId: companyId || '' },
      skip: !companyId,
    }
  );
}
